import {
  Grid,
  TextField,
  Typography,
  DialogActions,
  Button,
  Box,
  Divider,
} from "@mui/material";
import InsumosPrenda from "./InsumosPrenda";
import { modifyPrenda, createPrenda } from "../functions";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import PrendaImage from "./PrendatImage";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import InventoryIcon from "@mui/icons-material/Inventory";

const inputSx = {
  "& .MuiOutlinedInput-root": {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "0.9rem",
    borderRadius: 2,
    "&.Mui-focused fieldset": { borderColor: "#f43f5e" },
  },
  "& label": { fontFamily: "'Poppins', sans-serif" },
  "& label.Mui-focused": { color: "#f43f5e" },
  ".dark & .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255,255,255,0.2)" },
  ".dark & .MuiInputLabel-root": { color: "rgba(255,255,255,0.6)" },
  ".dark & .MuiInputBase-input": { color: "#f3f4f6" },
};

const PrendaForm = ({ mode, defaultData, handleClose }) => {
  const { productIdSelected } = useSelector(({ producto }) => producto);
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [imagen, setImagen] = useState("");
  const [prendaInsumo, setPrendaInsumo] = useState([]);

  useEffect(() => {
    if (mode === "PUT") {
      setNombre(defaultData?.nombre);
      setDescripcion(defaultData?.descripcion);
      setImagen(defaultData?.imagen);
    }
  }, [defaultData, mode]);

  const submitAction = async () => {
    let data = {
      id: mode === "POST" ? 0 : defaultData.id,
      nombre,
      descripcion,
      imagen,
      productoId: productIdSelected,
    };
    if (mode === "POST") {
      await createPrenda(data, prendaInsumo.length > 0 ? prendaInsumo : undefined);
    } else {
      await modifyPrenda(data);
    }
    handleClose();
  };

  return (
    <Box sx={{
      minHeight: "calc(100vh - 72px)",
      display: "flex",
      flexDirection: "column",
      background: "#fafafa",
      ".dark &": { background: "#0f172a" },
    }}>
      <Grid container sx={{ flex: 1 }}>

        {/* ─── Panel izquierdo: detalles ─── */}
        <Grid item xs={12} md={5} sx={{
          p: 4,
          borderRight: "1px solid",
          borderColor: "rgba(244,63,94,0.15)",
          ".dark &": { borderColor: "rgba(244,63,94,0.2)" },
        }}>
          {/* Encabezado sección */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
            <ContentCutIcon sx={{ color: "#f43f5e", fontSize: 20 }} />
            <Typography sx={{
              fontFamily: "'Poppins', sans-serif", fontWeight: 700,
              fontSize: "0.85rem", textTransform: "uppercase",
              letterSpacing: "0.07em", color: "#be185d",
            }}>
              Detalles de la prenda
            </Typography>
          </Box>

          <Grid container spacing={2.5}>
            <Grid item xs={12}>
              <TextField
                label="Nombre"
                value={nombre || ""}
                fullWidth
                onChange={(e) => setNombre(e.target.value)}
                sx={inputSx}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                multiline
                rows={4}
                label="Descripción"
                value={descripcion || ""}
                fullWidth
                onChange={(e) => setDescripcion(e.target.value)}
                sx={inputSx}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider sx={{ borderColor: "rgba(244,63,94,0.15)", mb: 2 }} />
              <Typography sx={{
                fontFamily: "'Poppins', sans-serif", fontWeight: 600,
                fontSize: "0.75rem", color: "#be185d",
                textTransform: "uppercase", letterSpacing: "0.06em", mb: 1.5,
              }}>
                Imagen de la prenda
              </Typography>
              <PrendaImage url={imagen} setImagen={setImagen} />
            </Grid>
          </Grid>
        </Grid>

        {/* ─── Panel derecho: insumos ─── */}
        <Grid item xs={12} md={7} sx={{ p: 4 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
            <InventoryIcon sx={{ color: "#f43f5e", fontSize: 20 }} />
            <Typography sx={{
              fontFamily: "'Poppins', sans-serif", fontWeight: 700,
              fontSize: "0.85rem", textTransform: "uppercase",
              letterSpacing: "0.07em", color: "#be185d",
            }}>
              Insumos utilizados
            </Typography>
          </Box>
          <InsumosPrenda
            prendaInsumo={prendaInsumo}
            prendaId={mode === "POST" ? 0 : defaultData?.id}
            mode={mode}
            setPrendaInsumo={setPrendaInsumo}
          />
        </Grid>
      </Grid>

      {/* ─── Acciones ─── */}
      <Box sx={{
        px: 4, py: 2.5,
        borderTop: "1px solid rgba(244,63,94,0.15)",
        display: "flex", justifyContent: "flex-end", gap: 1.5,
        background: "#fff",
        ".dark &": { background: "#1e293b", borderColor: "rgba(244,63,94,0.2)" },
      }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          sx={{
            fontFamily: "'Poppins', sans-serif", fontWeight: 600, borderRadius: 2,
            borderColor: "#f43f5e", color: "#f43f5e",
            "&:hover": { borderColor: "#e11d48", background: "#fff0f6" },
          }}
        >
          Cancelar
        </Button>
        <Button
          onClick={submitAction}
          variant="contained"
          sx={{
            fontFamily: "'Poppins', sans-serif", fontWeight: 600, borderRadius: 2,
            background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
            boxShadow: "0 4px 14px rgba(244,63,94,0.35)",
            "&:hover": { background: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
          }}
        >
          Guardar prenda
        </Button>
      </Box>
    </Box>
  );
};
export default PrendaForm;
